import styled from 'styled-components';

//components
import { SectionWrap } from '@/containers-ai/SectionHeading';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const HeroSection = styled.header`
  position: relative;
  background: radial-gradient(
    ellipse 78% 68% at 50% 0%,
    #0f555c 0%,
    #0c3f45 21%,
    #0a282d 42%,
    ${homeColor.bg} 88%
  );
`;

export const HeroInner = styled(SectionWrap)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  text-align: center;
  padding: 40px 29px;

  ${screen.md} {
    padding: 40px 47px;
    gap: 50px;
  }

  ${screen.lg} {
    padding: 60px 126px;
    gap: 60px;
  }

  ${screen.xxlg} {
    padding: 80px 280px;
    gap: 79px;
  }
`;

export const HeroCopy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const HeroTitle = styled.h1`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.08;
  font-size: 28px;
  margin: 0;
  color: ${homeColor.white};

  ${screen.md} {
    font-size: 36px;
  }

  ${screen.lg} {
    font-size: 48px;
  }
`;

export const HeroSub = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 500;
  font-size: 15px;
  line-height: 1.6;
  color: ${homeColor.muted};
  max-width: 46em;
  margin: 0;
  text-wrap: balance;

  ${screen.md} {
    font-size: 17px;
  }
`;
